import {
    FETCH_CURRENT_ACCOUNT,
    FETCH_CURRENT_ACCOUNT_FAILURE,
    FETCH_CURRENT_ACCOUNT_SUCCESS,
} from 'store/actions/types';

export const fetchCurrentAccount = () => {
    return {
        type: FETCH_CURRENT_ACCOUNT,
    };
};

export const fetchCurrentAccountFailure = (payload) => {
    return {
        type: FETCH_CURRENT_ACCOUNT_FAILURE,
        payload: payload,
    };
};

export const fetchCurrentAccountSuccess = (payload) => {
    return {
        type: FETCH_CURRENT_ACCOUNT_SUCCESS,
        payload: payload,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/accounts/fetchCurrentAccount.js